import React, { useContext, useState } from 'react'
import QuickBuyContext from '@context/QuickBuyContext'
import { X } from '@phosphor-icons/react'
import {
  Dialog,
  DialogPanel,
} from "@headlessui/react"
import SeeAllReviews from './SeeAllReviews'
import WriteAReview from './WriteAReview'

const ReviewsPanel = ({ratings, reviews, fitToSize, product}) => {
  const { showReviews, setShowReviews, showWriteReview, setShowWriteReview } =
    useContext(QuickBuyContext)

  const closeReviewPanel = () => {
    setShowReviews(false)
    setShowWriteReview(false)
  }

  const openState = showReviews || false;
  return (
    <React.Fragment>
      <Dialog
        open={openState}
        onClose={() => closeReviewPanel()}
        className="relative z-[53]"
      >
        <div className="fixed inset-0 w-screen bg-black bg-opacity-60">
          <DialogPanel
            transition
            className="flex w-full h-screen justify-end duration-150 ease-out data-[enter]:translate-x-full data-[leave]:translate-x-full"
          >
            <div className="w-full md:w-[512px] h-full bg-white drop-shadow-lg flex flex-col">
              <div className="flex flex-nowrap items-center justify-between p-4">
                <div className="inline-flex gap-x-2 items-center">
                  <h2 className="m-0">{showWriteReview ? 'Write a Review' : 'Reviews'}</h2>
                </div>
                <X
                  className="cursor-pointer"
                  size={24}
                  weight="light"
                  onClick={() => closeReviewPanel()}
                />
              </div>

              <div className="overflow-y-scroll scrollbar-hide grid flex-grow px-4">
                {showWriteReview ? (
                  <WriteAReview product={product} />
                ) : (
                  <SeeAllReviews ratings={ratings} reviews={reviews} fitToSize={fitToSize} />
                )}
              </div>
            </div>
          </DialogPanel>
        </div>
      </Dialog>
    </React.Fragment>
  );
}

export default ReviewsPanel